import {useMaterialsProducts, MaterialSource} from '@domain/materials'

import {useUrlParam} from '../../../routing'
import {getProductsPerMaterialSource} from '../../helpers/getProductsPerMaterialSource'

export const useMaterialsProductsQuery = (materialSource?: MaterialSource) => {
  const plantCode = useUrlParam('plantCode')

  return useMaterialsProducts({
    plantCode,
    options: {
      select: (data) => {
        if (!materialSource) {
          return data
        }
        return getProductsPerMaterialSource(data, materialSource)
      }
    }
  })
}
